export const systemUrl = 'https://connect.datalogics.co.il/rest/';
//const token = '1920837902173901273091';

const fetchData = async (postData) => {
    try {


        
        let systemUrlLocal = systemUrl + postData.action + '?token=' + postData.token;        

        if (postData.url) {
            systemUrlLocal = postData.url
        }

        
        

        if (postData.get && postData.order_id && postData.get==1) {
            systemUrlLocal += "&order_id=" + postData.order_id;
        }

        console.log(systemUrlLocal,postData)

        const response = await fetch(systemUrlLocal , {
            method: 'POST',
            //mode: 'no-cors',
            //credentials: 'include',
            // headers: {
            //     'Content-Type': 'application/json',
            // },
            body: JSON.stringify(postData),
            cache: 'no-cache',
            redirect: 'follow',
            referrer: 'no-referrer',
        });
        const result = await response.json();
        return result;
    } catch (err) {
        console.error('Error fetching data:', err);
        let error = err;
        return false;
    }
};



export default fetchData;